import { render, staticRenderFns } from "./WhatsappCard.vue?vue&type=template&id=2d626df1&"
import script from "./WhatsappCard.vue?vue&type=script&lang=js&"
export * from "./WhatsappCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports